import serverOptimized from '@nykaa/utils/serverOptimized';

export default serverOptimized(
  () => import(/* webpackChunkName: "Auth" */ './Loadable'),
  ''
);
